var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgM1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 652 272",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316 52c-46.9 0-85 38.1-85 85s38.1 85 85 85 85-38.1 85-85-38.1-85-85-85zm0 111.7l-32.5-46.5v69.4h-17.2V87.3h18.6l31.6 47.2 5.4-9h18.5zm55.5 23h-30.6v-15.3h5.7v-61.1H331l13.7-22.9h19.1v84h7.7z",
    fill: "#ff9e1b"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA2NTIgMjcyIiB2aWV3Qm94PSIwIDAgNjUyIDI3MiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMzE2IDUyYy00Ni45IDAtODUgMzguMS04NSA4NXMzOC4xIDg1IDg1IDg1IDg1LTM4LjEgODUtODUtMzguMS04NS04NS04NXptMCAxMTEuNy0zMi41LTQ2LjV2NjkuNGgtMTcuMnYtOTkuM2gxOC42bDMxLjYgNDcuMiA1LjQtOWgxOC41em01NS41IDIzaC0zMC42di0xNS4zaDUuN3YtNDUuOC05LjYtNS43aC0xNS42bDEzLjctMjIuOWgxOS4xdjg0aDcuN3oiIGZpbGw9IiNmZjllMWIiLz48L3N2Zz4=";
export { SvgM1 as ReactComponent };